import ContactEmail from "@/views/permits/ContactEmail.vue";
import OperatingHours from "@/views/permits/OperatingHours.vue";
import Review from "@/views/permits/Review.vue";
import Signature from "@/views/permits/Signature.vue";
import SiteInfo from "@/views/permits/SiteInfo.vue";
import Renewal from "@/views/permits/Renewal.vue";
import SiteInfoRenewal from "@/views/permits/SiteInfoRenewal.vue";
import RecyclingFacility from "@/ts/modules/permits.rfa";
import CCDD from "@/ts/modules/permits.ccdd";
import RockCrushing from "@/ts/modules/permits.rc";

export default {
    ContactEmail,
    OperatingHours,
    Review,
    Signature,
    SiteInfo,
    SiteInfoRenewal,
    RecyclingFacility,
    CCDD,
    RockCrushing
}
